<template>
    <article class="asset-form">
        <section class="row p-3 my-4">

            <div class="col-4">
                <h5 class="text-muted d-block">Type</h5>
                <div v-if="!editing">
                    <iconized-info icon="folder-open"> <div> <span>{{ asset.type.name }}</span> </div> </iconized-info>
                </div>
                <div v-else> <v-select label="name" value="id" :options="assetTypes.types" v-model="asset.type" /> </div>
            </div>

            <div class="col-4">
                <h5 class="text-muted d-block">Status</h5>
                <div v-if="!editing">
                    <iconized-info icon="toggle-off"> <div> <span>{{ asset.status.name }}</span> </div> </iconized-info>
                </div>
                <div v-else> <v-select label="name" value="id" :options="assetTypes.statuses" v-model="asset.status" /> </div>
            </div>

            <div class="col-4">
                <h5 class="text-muted d-block">Condition</h5>
                <div v-if="!editing">
                    <iconized-info icon="thermometer-three-quarters"> <div> <span>{{ asset.condition.name }}</span> </div> </iconized-info>
                </div>
                <div v-else> <v-select label="name" value="id" :options="assetTypes.conditions" v-model="asset.condition" /> </div>
            </div>

        </section>

        <br />

        <section class="row my-6">

            <div class="col-6 table-responsive">
                <table class="table table-borderless">
                    <tbody>

                        <tr>
                            <th>Name</th>
                            <td>
                                <input
                                    type="text"
                                    name="name"
                                    v-model="asset.name"
                                    class="form-control form-control-sm border border-dark"
                                    :disabled="!editing" />
                            </td>
                        </tr>

                        <tr>
                            <th>Installation Date</th>
                            <td>
                                <datepicker
                                    name="installation_date"
                                    v-model="asset.installation_date"
                                    :disabled-dates="{ from: new Date() }"
                                    :bootstrap-styling="true"
                                    input-class="form-control form-control-sm"
                                    calendar-class="bg-skyblue"
                                    :disabled="!editing" />
                            </td>
                        </tr>

                        <tr>
                            <th>Quantity</th>
                            <td>
                                <input
                                    type="number"
                                    step="1"
                                    name="quantity"
                                    v-model="asset.quantity"
                                    class="form-control form-control-sm border border-dark"
                                    :disabled="!editing" />
                            </td>
                        </tr>

                        <tr>
                            <th>Unit Price</th>
                            <td>
                                <input
                                    type="number"
                                    step=".01"
                                    name="unit_price"
                                    v-model="asset.unit_price"
                                    class="form-control form-control-sm border border-dark"
                                    :disabled="!editing" />
                            </td>
                        </tr>

                        <tr>
                            <th>Total Value</th>
                            <td>{{ totalPrice }} <abbr title="Rwandan franc">RWF</abbr>s</td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div class="col-6">
                <div class="mt-3 mb-3"> <span class="text-muted text-uppercase notes-title">Notes</span> </div>
                <div v-if="asset.notes && notesExpanded && !editing">
                    <p v-for="(paragraph, idx) in notesParagraphed" :key="idx">{{ paragraph }}</p>
                </div>
                <div v-else-if="asset.notes && notesParagraphed.length > 0 && !editing"> <p> {{ firstParagraphOfNotes }} </p> </div>
                <div v-else-if="editing">
                    <textarea name="notes" v-model="asset.notes" class="form-control border border-dark" rows="8" />
                </div>
                <div v-else class="text-muted" >No notes.</div>

                <div class="text-center" v-if="asset.notes && !editing" >
                    <div class="btn btn-sm btn-secondary border border-dark" @click="toggleNotesExpansion">
                        {{ notesExpanded ? 'Less' : 'More' }}
                    </div>
                </div>
            </div>

    </section>
  </article>
</template>

<script>
import DatePicker from 'vuejs-datepicker';
import VSelect from 'vue-select';
import IconizedInfo from './IconizedInfoComponent';
import Utils from '../mixins/UtilsMixin';

export default {
    components: {
        datepicker: DatePicker,
        'v-select': VSelect,
        'iconized-info': IconizedInfo,
    },

    mixins: [
        Utils,
    ],

    props: {
        editing: {
            type: Boolean,
            default: false,
        },
        asset: {
            type: Object,
            default: () => {},
        },
        assetTypes: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            notesExpanded: false,
        };
    },

    computed: {
        firstParagraphOfNotes() {
            if (this.notesParagraphed.length > 0) {
                return this.notesParagraphed[0];
            }

            return '';
        },
        hasNotes() {
            return this.asset && this.asset.notes && typeof this.asset.notes === 'string';
        },
        notesParagraphed() {
            return this.hasNotes ? this.textToParagraphs(this.asset.notes) : [];
        },
        totalPrice() {
            let price = this.asset.quantity * this.asset.unit_price;
            return price ? price : 0;
        },

        assetTypeId() {
            if (this.asset.type) {
                return this.asset.type.id;
            }
        },
        assetStatusId() {
            if (this.asset.status) {
                return this.asset.status.id;
            }
        },
        assetConditionId() {
            if (this.asset.condition) {
                return this.asset.condition.id;
            }
        },
    },

    watch: {
        assetTypeId() {
            if (this.asset.type) {
                this.asset.asset_type_id = this.assetTypeId;
            }
        },
        assetStatusId() {
            if (this.asset.status) {
                this.asset.asset_status_id = this.assetStatusId;
            }
        },
        assetConditionId() {
            if (this.asset.condition) {
                this.asset.asset_condition_id = this.assetConditionId;
            }
        },
    },

    methods: {
        toggleNotesExpansion() {
            this.notesExpanded = !this.notesExpanded;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/asset-register/AssetFormComponent.vue